import { Locales, type LocalesType } from '@/types';

/**
 * 言語を判定して適切な言語を返す
 * @param lang 言語
 * @returns 言語
 */
export function resolveLanguage(lang: string | undefined): LocalesType {
  if (lang && lang in Locales) {
    return lang as LocalesType;
  }
  return Locales.ja.value;
}

/**
 * 多言語テキストを取得
 * @param lang 言語
 * @param texts テキスト { ja: '日本語', en: 'English' }
 * @returns テキスト
 */
export function getLocalizedText(lang: string | undefined, texts: Record<LocalesType, string>): string {
  const resolvedLang = resolveLanguage(lang);
  return texts[resolvedLang] || texts[Locales.ja.value] || '';
}

/**
 * 日本語かどうかを判定
 * @param lang 言語
 * @returns 日本語の場合true
 */
export function isJapanese(lang: string | undefined): boolean {
  return resolveLanguage(lang) === Locales.ja.value;
}

/**
 * 英語かどうかを判定
 * @param lang 言語
 * @returns 英語の場合true
 */
export function isEnglish(lang: string | undefined): boolean {
  return resolveLanguage(lang) === Locales.en.value;
}

/**
 * 指定された言語かどうかを判定
 * @param lang 言語
 * @param targetLang 判定したい言語
 * @returns 指定された言語の場合true
 */
export function isLanguage(lang: string | undefined, targetLang: LocalesType): boolean {
  return resolveLanguage(lang) === targetLang;
}
